import { css } from 'linaria';

export namespace Styles {
  const ulHeight = '3px';

  export const linkWrapper = css`
    --typography-base-color: var(--text-minor);
    --typography-accent-color: var(--text-primary);
    --underline-base-background-color: transparent;
    --underline-accent-background-color: #444b5b;

    --typography-color: var(--typography-base-color);
    --underline-background-color: var(--underline-base-background-color);

    height: 100%;
    text-decoration: unset;
    cursor: pointer;

    &:hover {
      --typography-color: var(--typography-accent-color);
      --underline-background-color: var(--control-accent);
    }
  `;

  export const linkWrapperAccent = css`
    --typography-color: var(--typography-accent-color);
    --underline-background-color: var(--control-accent);
  `;

  export const typography = css`
    display: flex !important;
    align-items: center;
    height: calc(100% - ${ulHeight});
    color: var(--typography-color);
    transform: translate(0, calc(${ulHeight} / 2));
  `;

  export const underline = css`
    width: 100%;
    height: ${ulHeight};
    background-color: var(--underline-background-color);
  `;

  export const navigationWrapper = css`
    height: 100%;
  `;

  export const ul = css`
    /* <ul> & <li> used only as blocks for ARIA attributes placement so we have to reset all styles */
    all: unset;
    display: flex;
    height: 100%;
  `;

  export const li = css`
    all: unset;

    & + & {
      margin-left: 24px;
    }
  `;

  export const liActive = css`
    pointer-events: none;
  `;
}
